import React from "react";
import ReactDOM from "react-dom/client";
//import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import ThemeContext from "./context/ThemeContext";
import { FilterProvider } from "./context/FilterContext";
import { ChatProvider } from "./context/ChatContext";
import { BranchDefinationContextProvider } from "./context/BranchDefinationContext";
import { ConfigProvider } from "./context/ConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <ThemeContext>
          <ConfigProvider>
            <FilterProvider>
              <ChatProvider>
                <BranchDefinationContextProvider>
                  <App />
                </BranchDefinationContextProvider>
              </ChatProvider>
            </FilterProvider>
          </ConfigProvider>
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
